import React from 'react';
import { useNavigate } from 'react-router-dom';
import useIsTestStudent from '../../hooks/useIsTestStudent';
import './training-entry.scss';

const TrainingEntry = () => {
  const navigate = useNavigate();
  const isTestStudent = useIsTestStudent();

  if (!isTestStudent) {
    return null;
  }

  return (
    <section className="tr-entry" aria-labelledby="tr-entry-title">
      <h2 className="tr-entry__title" id="tr-entry-title">Тренування</h2>
      <p className="tr-entry__text">Доступне завжди — повторюйте скільки хочете.</p>
      <button type="button" className="tr-entry__card" onClick={() => navigate('/training/verbs')}>
        <span className="tr-entry__icon" aria-hidden="true">🗣️</span>
        <span className="tr-entry__main">
          <b>Тренування дієслів</b>
          <span>Форми дієслів у часах, які ви вже пройшли: вибір форми, речення з пропуском, діалог.</span>
        </span>
        <span className="tr-entry__go" aria-hidden="true">›</span>
      </button>
      <button type="button" className="tr-entry__card" onClick={() => navigate('/training/words')}>
        <span className="tr-entry__icon tr-entry__icon--warm" aria-hidden="true">⚡</span>
        <span className="tr-entry__main">
          <b>Вивчення слів</b>
          <span>Бліц на 60 секунд, пари на час і досягнення — слова з уроків, які ви вже пройшли.</span>
        </span>
        <span className="tr-entry__go" aria-hidden="true">›</span>
      </button>
    </section>
  );
};

export default TrainingEntry;
